import { Button } from 'antd';
import { ReactNode } from 'react';
import './BlackButton.css';

interface BlackButtonProps {
  onClick?: () => void;
  children: ReactNode;
  className?: string;
  htmlType?: "button" | "submit" | "reset";
  type?: "primary" | "default";
  size?: "large" | "middle" | "small";
}

export const BlackButton = ({
  onClick,
  children,
  className = '',
  htmlType = 'button',
  type = 'default',
  size = 'middle',
  ...rest
}: BlackButtonProps) => {
  return (
    <Button
      onClick={onClick}
      htmlType={htmlType}
      type={type}
      size={size}
      className={`black-button ${className}`}
      {...rest}
    >
      {children}
    </Button>
  );
}; 